import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, tap } from 'rxjs';
import { BackendService } from '../backend/backend.service';
import { StorageService } from '../storage/storage.service';
import { ConfigurationService } from '../configs/configuration';
import { AllStatus } from '../status/all-status';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public isLoggedIn: boolean = false;
  private token: string = "";
  private refreshToken: string = "";
  private allStatus = inject(AllStatus);

  private backendService: BackendService = inject(BackendService);
  private storageService: StorageService = inject(StorageService);
  private configuration: ConfigurationService  = inject(ConfigurationService);

  constructor(private http: HttpClient) { 
    this.isLoggedIn = !!sessionStorage.getItem("user");
    if(this.isLoggedIn){
      this.allStatus.isAutorization = true;
      const userInfo = JSON.parse(sessionStorage.getItem("user") as string);
      this.token = userInfo.access_token;
      this.TokenRefresh = userInfo.refresh_token;             
    }
  }

  get Token(){
    return this.token;
  }
  set Token(val:string){
    this.token = val;
  }
  get TokenRefresh(){
    return this.refreshToken;
  }
  set TokenRefresh(val:string){
    this.refreshToken = val;
  }

  getUserToken(login: string, password: string, refId: string ): Observable<any> {
    // const send = new FormData();
    // send.append("login", login);
    // send.append("password", password);
    // send.append("ref_id", refId);
    const send = {
      login,
      password,
      ref_id: refId
    }
    return this.http.post<any>(`${this.backendService.getApiUrl()}/user/login`, send).pipe(
      tap((auth) => {
        if (auth.status === 302) {
          this.storageService.set("user", auth.data);
          this.allStatus.isAutorization = true;
          this.isLoggedIn = true;
          this.Token = auth.data.access_token;
          this.TokenRefresh = auth.data.refresh_token;
        }
      }),
      catchError( error => { throw error } )
    );

  }

  refreshAuthToken() { 
    const refresh_token = this.TokenRefresh; 
    return this.http.post<any>(`${this.backendService.getApiUrl()}/user/refresh-token`, {"refresh_token": refresh_token}).pipe(
      tap((auth) => {     
        if (auth.status === 302) {
          this.storageService.set("user", auth.data);
          this.allStatus.isAutorization = true;
          this.isLoggedIn = true;
          this.Token = auth.data.access_token;
          this.TokenRefresh = auth.data.refresh_token;
        }
      }),
      catchError( error => { throw error } )
    )
  }

  logout(){
    this.http.get<any>(`${this.backendService.getApiUrl()}/logout` ).subscribe({ next: ()=> {}, error: (err: any) =>{ 
      // if(this.notification.getError()){
      //   this.notification.display();
      // }
    }});
    this.exitCompletion();
    // sessionStorage.removeItem('ROOMS');
  }

  exitCompletion(){
    this.isLoggedIn = false;  
    this.allStatus.isAutorization = false;  
    this.allStatus.isEditUserInWaiting = false;
    this.configuration.clearConfig();
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('CONFIGURATION');
  }

  badRefresh(){
    this.allStatus.setRefreshNotValid(true);
    this.allStatus.isAutorization = false;
  }
}
